module.exports = __webpack_public_path__ + "static/media/attendance.6cfb6545.svg";